var address = {
  first_name: null,
  last_name: null,
  address1: null,
  address2: null,
  city: null,
  country: null,
  state: null,
  zipcode: null,
  gift_note: null,
  phone: null,
  email: null,
  email_add: null,
  fname: null,
  lname: null,
  gift_note_add: null,
  date: null
};

var gifting = {
  currentProductHandle: null,
  product: {},
  variantId: null,
  metafields: {
    charge_interval_frequency:null,
    shipping_interval_frequency:null,
    shipping_interval_unit_type:null
  },
  images: {}
}

var cart = [];

var giftSelectors = {
  giftSelect: document.querySelectorAll('[data-onchange]'),
  inspirationSelect: document.querySelectorAll('[data-onclick]'),
  viewGiftSelect : document.querySelectorAll('[data-buy_gift]'),
  checkEmailSelect: document.querySelectorAll('[data-email_check]'),
  giftVariantID: document.querySelector('[data_varinat_id]').getAttribute('data_varinat_id'),
  addToCartSelect: document.querySelectorAll('[data-add-to-cart]'),
  closeCurrentModal: document.querySelectorAll('[data-close_current_modal]'),
  goBackimmediateModal : document.querySelectorAll('[data-go_back_modal]')
};

class giftJS  {
    
  constructor () {
    this.bindEvents();
  }

  bindEvents = () => {
    if (giftSelectors.giftSelect) {
      giftSelectors.giftSelect.forEach((product) => {
        product.addEventListener('change', (event) => {
          this._giftProduct(event);
        })
      });
    }
    if (giftSelectors.inspirationSelect) {
      giftSelectors.inspirationSelect.forEach((product) => {
        product.addEventListener('click', (event) => {
          event.stopPropagation();
          this._giftProduct(event);
        })
      });
    }
    if (giftSelectors.viewGiftSelect) {
      giftSelectors.viewGiftSelect.forEach((gift) => {
        gift.addEventListener('click', (event) => {
          this._viewGiftShop(event);
        })
      })
    }
    if (giftSelectors.checkEmailSelect) {
      giftSelectors.checkEmailSelect.forEach((email) => {
        email.addEventListener('click', (event) => { 
          this._checkEmailGiftForm(event);
        })
      })
    }
    if (giftSelectors.addToCartSelect) {
      giftSelectors.addToCartSelect.forEach((item) => {
        item.addEventListener('click', (event) => {
          this._hasRechargeCheckout(event);
        })
      })
    }
    if (giftSelectors.closeCurrentModal) {
      giftSelectors.closeCurrentModal.forEach((close) => {
        close.addEventListener('click', () => {
          this._closeCurrentModal(close);
        })
      })
    }
    if (giftSelectors.goBackimmediateModal) {
      giftSelectors.goBackimmediateModal.forEach((goBack) => {
        goBack.addEventListener('click', () => {
          this._goBackModal(goBack);
        })
      })
    }
  }

  /**
   * Call Function onChange event of gift product radio button:
   */

  _giftProduct = (event) => {
    if (document.querySelector('.quick-modal')) {
      if (document.querySelector('.quick-modal').classList.contains('open')) {
        document.querySelector('.quick-modal').classList.remove('open');
      }
    }
    gifting.currentProductHandle = event.target.attributes.data_handle.value;
    gifting.variantId = event.target.attributes.data_varinat_id.value;
    gifting.metafields.charge_interval_frequency = event.target.attributes.data_charge_interval_frequency.value;
    gifting.metafields.shipping_interval_frequency = event.target.attributes.data_shipping_interval_frequency.value;
    gifting.metafields.shipping_interval_unit_type = event.target.attributes.data_shipping_interval_unit_type.value;
  
    if (event.target.closest('.card')) {
      if (event.target.closest('.card').querySelector('#buy_gift')) {
        event.target.closest('.card').querySelector('#buy_gift').removeAttribute('disabled', 'disabled');
        event.target.closest('.card').querySelector('#buy_gift').classList.remove('btn-disabled');
      }
    }
    
    new Shopify.CountryProvinceSelector('country', 'administrative_area_level_1', {
      hideElement: 'data-hide-ele'
    });

    this._flatPickerTrigger();
  }

  // Date picker js for gift email: 
  _flatPickerTrigger = () => {
    let datePicker = document.getElementById('datepicker');
    let date_values =  {
      enableTime: true,
      minDate: "today",
      dateFormat: "Y-m-d"
    }
    flatpickr(datePicker,date_values);
  }
  
  /**
   * Call Function onclick event of buy gift & store product data:
   */

  _viewGiftShop = (event) => {
    fetch(`/products/${gifting.currentProductHandle}.js`)
    .then(response => {
      var res = response.json();
      res.then(
      function (result) {
        gifting.product = result;
        if (document.getElementById('gifting_img') || document.getElementById('gifting_title') || document.getElementById('gifting_price')) {
          document.getElementById('gifting_img').src = gifting.product.featured_image;
          document.getElementById('gifting_title').innerHTML = gifting.product.title;
          document.getElementById('gifting_price').innerHTML = Shopify.formatMoney(gifting.product.price, window.globalVariables.money_format);
        }
        if (document.getElementById('gifting_email_img') || document.getElementById('gifting_email_title') || document.getElementById('gifting_email_price')) {
          document.getElementById('gifting_email_img').src = gifting.product.featured_image;
          document.getElementById('gifting_email_title').innerHTML = gifting.product.title;
          document.getElementById('gifting_email_price').innerHTML = Shopify.formatMoney(gifting.product.price, window.globalVariables.money_format);
        }
      });
    });
  
    fetch(`/products/${gifting.currentProductHandle}?view=json`,{
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => {
      var responseData = response.json();
      responseData.then(
        function (data) {
          gifting.images = data.product.images;
        });
    });
  }

  /**
   * Get Gift Form data & add validation:
   */

  _checkEmailGiftForm = (event) => {
    var first_name =  document.querySelector('#first_name').value;
    var last_name = document.querySelector('#last_name').value;
    var email = document.querySelector('#email_name').value;
    var address1 =  document.querySelector('#street_number').value;
    var city = document.querySelector('#locality').value;
    var zipcode = document.querySelector('#zipcode').value;
    var phone = document.querySelector('#phone').value;
  
    var date =  document.querySelector('#datepicker').value;
    var fname = document.querySelector('#first_name_add').value;
    var gift_email = document.querySelector('#email_add').value;
    var lname =  document.querySelector('#last_name_add').value;
  
    if (event.target.className == 'btn btn-primary gift-immediate-form') {
      if (first_name === '' && last_name === '' && email === '' && address1 === '' && city === '' && zipcode === '' && phone === '') {
        document.querySelector('#first_name').classList.add('border-danger');
        document.querySelector('#last_name').classList.add('border-danger');
        document.querySelector('#email_name').classList.add('border-danger');
        document.querySelector('#street_number').classList.add('border-danger');
        document.querySelector('#locality').classList.add('border-danger');
        document.querySelector('#zipcode').classList.add('border-danger');
        document.querySelector('#phone').classList.add('border-danger'); 
        return false;
      } else if (first_name === '' || first_name === null || first_name === undefined) {
        document.querySelector('#first_name').classList.add('border-danger');
      } else if (last_name === '' || last_name === null || last_name === undefined) {
        document.querySelector('#first_name').classList.remove('border-danger');
        document.querySelector('#last_name').classList.add('border-danger');
      } else if (email === '' || email === null || email === undefined) {
        document.querySelector('#last_name').classList.remove('border-danger');
        document.querySelector('#email_name').classList.add('border-danger');
      } else if (address1 === '' || address1 === null || address1 === undefined) {
        document.querySelector('#email_name').classList.remove('border-danger');
        document.querySelector('#street_number').classList.add('border-danger');
      } else if (city === '' || city === null || city === undefined) {
        document.querySelector('#street_number').classList.remove('border-danger');
        document.querySelector('#locality').classList.add('border-danger');
      } else if (zipcode === '' || zipcode === null || zipcode === undefined) {
        document.querySelector('#locality').classList.remove('border-danger');
        document.querySelector('#zipcode').classList.add('border-danger');
      } else if (phone === '' || phone === null || phone === undefined) {
        document.querySelector('#zipcode').classList.remove('border-danger');
        document.querySelector('#phone').classList.add('border-danger'); 
      } else {
        document.querySelector('#first_name').classList.remove('border-danger');
        document.querySelector('#last_name').classList.remove('border-danger');
        document.querySelector('#email_name').classList.remove('border-danger');
        document.querySelector('#street_number').classList.remove('border-danger');
        document.querySelector('#locality').classList.remove('border-danger');
        document.querySelector('#zipcode').classList.remove('border-danger');
        document.querySelector('#phone').classList.remove('border-danger'); 
        this._emailValidation(email, event.target.className);
      }
    } else if (event.target.className == 'btn btn-primary gift-email-form') {
      if (fname === '' && lname === '' && gift_email === '' && date === '') {
        document.querySelector('#first_name_add').classList.add('border-danger');
        document.querySelector('#last_name_add').classList.add('border-danger');
        document.querySelector('#datepicker').classList.add('border-danger');
        document.querySelector('#email_add').classList.add('border-danger');
        return false;
      } else if (fname === '' || fname === null || fname === undefined) {
        document.querySelector('#first_name_add').classList.add('border-danger');
      } else if (lname === '' || lname === null || lname === undefined) {
        document.querySelector('#first_name_add').classList.remove('border-danger');
        document.querySelector('#last_name_add').classList.add('border-danger');
      } else if (gift_email === '' || gift_email === null || gift_email === undefined) {
        document.querySelector('#last_name_add').classList.remove('border-danger');
        document.querySelector('#email_add').classList.add('border-danger');
      } else if (date === '' || date === null || date === undefined) {
        document.querySelector('#email_add').classList.remove('border-danger');
        document.querySelector('#datepicker').classList.add('border-danger');
      } else {
        document.querySelector('#first_name_add').classList.remove('border-danger');
        document.querySelector('#last_name_add').classList.remove('border-danger');
        document.querySelector('#datepicker').classList.remove('border-danger');
        document.querySelector('#email_add').classList.remove('border-danger');
        this._emailValidation(gift_email, event.target.className);
      }
    }
  }

   /**
   * Check email is valid or not API call:
   */

  _emailValidation = (email, result_modal) => {
    var email = email;
    const emailData = { email: email };
  
    fetch('https://app.giftotter.com/gifts/check_email',{
      method: 'POST',
      headers: {
        Accept: 'application/json, text/javascript, /; q=0.01',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'X-Gift-Access-Token': 'd9875b7293c00dd9',
        'Cache-Control': 'must-revalidate',
        'Cache-Control': 'no-cache',
        'Cache-Control': 'no-store',
        'Content-type': 'application/json; charset=UTF-8',
        Pragma: 'no-cache',
        crossDomain: true,
      },
      body: JSON.stringify(emailData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'error') {
        notificationEle.updateNotification('Error', data.message, {
          type: 'error',
          timeout: 3000
        });
        return false;
      } else if (data.status === 'warning') {
        notificationEle.updateNotification('Error', data.message, {
          type: 'error',
          timeout: 3000
        });
        return false;
      } else {
        this._addressValidation(result_modal);
      }
    })
  }
  /**
   * Check address is valid or not API call:
   */

  _addressValidation = (result_modal) => {
    address.first_name =  document.querySelector('#first_name').value;
    address.last_name = document.querySelector('#last_name').value;
    address.address1 =  document.querySelector('#street_number').value;
    address.address2 = document.querySelector('#route').value;
    address.city = document.querySelector('#locality').value;
    address.country = document.querySelector('#country').value;
    address.state = document.querySelector('#administrative_area_level_1').value;;
    address.zipcode = document.querySelector('#zipcode').value;
    address.gift_note = document.querySelector('#add_p_note').value;
    address.phone = document.querySelector('#phone').value;
    address.email = document.querySelector('#email_name').value;
    address.email_add = document.querySelector('#email_add').value;
    address.fname = document.querySelector('#first_name_add').value;
    address.lname = document.querySelector('#last_name_add').value;
    address.gift_note_add = document.querySelector('#gift_note_add').value;
    address.date = document.querySelector('#datepicker').value;
  
    fetch('https://app.giftotter.com/gifts/address_validation',{
      method: 'POST',
      headers: {
        Accept: 'application/json, text/javascript, /; q=0.01',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'X-Gift-Access-Token': 'd9875b7293c00dd9',
        'Cache-Control': 'must-revalidate',
        'Cache-Control': 'no-cache',
        'Cache-Control': 'no-store',
        'Content-type': 'application/json; charset=UTF-8',
        Pragma: 'no-cache',
        crossDomain: true,
      },
      body: JSON.stringify(address)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'errors') {
        notificationEle.updateNotification('Error', data.message, {
          type: 'error',
          timeout: 3000
        });
        return false;
      } else if (data.status === 'warning') {
        notificationEle.updateNotification('Error', data.message, {
          type: 'error',
          timeout: 3000
        });
        return false;
      } else {
        if (result_modal == 'btn btn-primary gift-immediate-form' ) {
          this._closeModal();
          document.querySelector('#result_enable_modal').classList.add('open');
          siteOverlay.prototype.showOverlay();
        } else if (result_modal == 'btn btn-primary gift-email-form') {
          this._closeModal();
          document.querySelector('#result_enable_email_modal').classList.add('open');
          siteOverlay.prototype.showOverlay();
        }
        var name = `${address.first_name} ${address.last_name}`;
        var addressdata = `${address.address1}, ${address.city}, ${address.state}, ${address.zipcode}`;
        var fullName = `${address.fname} ${address.lname}`;
        var emailAddress = `${address.email_add}`;
        var gift_note = address.gift_note;
        var gift_note_add = address.gift_note_add;
    
        if (name !== null && name !== '' && address.address1 !== null && address.address1 !== '') {
          document.getElementById('gifting_name').innerHTML =  name;
          document.getElementById('gifting_address').innerHTML = addressdata;
        } 
        if (fullName !== null && fullName !== '' && emailAddress !== null && emailAddress !== '') {
          document.getElementById('gifting_to').innerHTML =  fullName;
          document.getElementById('gifting_email').innerHTML = emailAddress;
        } 
        if (gift_note !== null && gift_note !== '' && gift_note !== undefined) {
          document.getElementById('note_desc').innerHTML = gift_note;
        } 
        if (gift_note_add !== null && gift_note_add !== '' && gift_note_add !== undefined) {
          document.getElementById('note_emaill_desc').innerHTML = gift_note_add;
        }
      }
    }).catch(function (error) {
      console.warn('Something went wrong.', error);
    });
  }

  /**
   * Get all line-item-properties & add to cart:
   */
  _hasRechargeCheckout = (event) => {
    const submitButton =  event.currentTarget;
    let isCheckOutURl = false;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const qtyValue = 1;
    var properties = {};
    var variantId = gifting.variantId;
    if (address.address1 !== '' && address.zipcode !== '' && address.city !== '' && address.phone !== '' && address.last_name !== '' && address.country !== '' && address.first_name !== '' && address.email !== '' && address.address1 !== null && address.zipcode !== null && address.city !== null && address.phone !== null && address.last_name !== null && address.country !== null && address.first_name !== null && address.email !== null && gifting.metafields.shipping_interval_frequency !== null && gifting.metafields.shipping_interval_frequency !== '' && gifting.metafields.shipping_interval_unit_type !== '' && gifting.metafields.shipping_interval_unit_type !== null && gifting.metafields.charge_interval_frequency !== null && gifting.metafields.charge_interval_frequency !== '') {
      properties = {
        "address1": address.address1,
        "zip": address.zipcode,
        "gift_note": address.gift_note,
        "city": address.city,
        "phone": address.phone,
        "province": address.state,
        "last_name": address.last_name,
        "country": address.country,
        "type": "gift-recharge-immediately",
        "first_name": address.first_name,
        "email": address.email,
        "gift_shipping_interval_frequency": gifting.metafields.shipping_interval_frequency,
        "gift_shipping_interval_unit_type": gifting.metafields.shipping_interval_unit_type,
        "gift_charge_interval_frequency": gifting.metafields.charge_interval_frequency,
        "address2": address.address2
      };
    } else if (address.address1 !== '' && address.zipcode !== '' && address.city !== '' && address.phone !== '' && address.last_name !== '' && address.country !== '' && address.first_name !== '' && address.email !== '' && address.address1 !== null && address.zipcode !== null && address.city !== null && address.phone !== null && address.last_name !== null && address.country !== null && address.first_name !== null && address.email !== null) {
      properties = {
        "address1": address.address1,
        "zip": address.zipcode,
        "gift_note": address.gift_note,
        "city": address.city,
        "phone": address.phone,
        "province": address.state,
        "last_name": address.last_name,
        "country": address.country,
        "type": "gift-immediately",
        "first_name": address.first_name,
        "email": address.email,
        "address2": address.address2
      };
    }
    else if (address.date !== '' && address.lname !== '' && address.fname !== '' && address.email_add !== '' && address.date !== null && address.lname !== null && address.fname !== null && address.email_add !== null && gifting.metafields.shipping_interval_frequency !== null && gifting.metafields.shipping_interval_frequency !== '' && gifting.metafields.shipping_interval_unit_type !== '' && gifting.metafields.shipping_interval_unit_type !== null && gifting.metafields.charge_interval_frequency !== null && gifting.metafields.charge_interval_frequency !== '') {
      properties = {
        "gift_note": address.gift_note_add,
        "gift_shipping_interval_frequency": gifting.metafields.shipping_interval_frequency,
        "date": address.date,
        "last_name": address.lname,
        "type": "gift-recharge-email",
        "first_name": address.fname,
        "email": address.email_add,
        "gift_shipping_interval_unit_type": gifting.metafields.shipping_interval_unit_type,
        "gift_charge_interval_frequency": gifting.metafields.charge_interval_frequency
      };
    } else if (address.date !== '' && address.lname !== '' && address.fname !== '' && address.email_add !== '' && address.date !== null && address.lname !== null && address.fname !== null && address.email_add !== null) {
      properties = {
        "gift_note": address.gift_note_add,
        "date": address.date,
        "last_name": address.lname,
        "type": "gift-email",
        "first_name": address.fname,
        "email": address.email_add
      };
    }
    else if (gifting.metafields.shipping_interval_frequency !== null && gifting.metafields.shipping_interval_frequency !== '' && gifting.metafields.shipping_interval_unit_type !== '' && gifting.metafields.shipping_interval_unit_type !== null && gifting.metafields.charge_interval_frequency !== null && gifting.metafields.charge_interval_frequency !== '') {
      properties = {
        "shipping_interval_unit_type": gifting.metafields.shipping_interval_unit_type,
        "charge_interval_frequency": gifting.metafields.charge_interval_frequency,
        "shipping_interval_frequency": gifting.metafields.shipping_interval_frequency,
        "type": "gift-box"
      } 
    } else {
      properties = {
        "type": "gift-box"
      } 
    }
    
    let data = {
      quantity: qtyValue,
      id: variantId,
      properties: properties
    };
  
    const body = JSON.stringify(data);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then(() => {
        fetch('/cart.json', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(data => {
          let res = data.json();
          res.then((result) => {
            cart.push(result.items);
            cart.forEach(value => {
              value.forEach(items => {
                if (items.properties.shipping_interval_unit_type != null || items.properties.shipping_interval_unit_type != undefined || items.properties.type == 'gift-recharge-immediately' || items.properties.type == 'gift-recharge-email') {
                  isCheckOutURl = true;
                }
              })
            });            
            if (isCheckOutURl) {
              this._redirectToCheckout();
            } else {
              window.location.href = '/checkout';
            }
          });
        })
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
    });
  };

   /**
   * Redirect to recharge checkout:
   */
  _redirectToCheckout = () => {
    function reChargeGetCookie(name) {
      return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
    }
    // Build the Checkout URL
    let ga_linker = '';
    const myshopify_domain = 'battlboxllc.myshopify.com';
    const token = reChargeGetCookie('cart');
    try {
      // Cross-domain tracking with Google Analytics
      ga_linker = ga.getAll()[0].get('linkerParam');
    } catch (e) {
      // 'ga' is not available
      ga_linker = '';
    }
    // Customer email address for use in the Checkout URL
    const customer_param = `customer_id=${window.theme.customersID}&customer_email=${window.theme.emailHashed}`;
    const checkout_url = `https://checkout.battlbox.com/r/checkout?myshopify_domain=${myshopify_domain}&cart_token=${token}&${ga_linker}&${customer_param}`;
    // window.location.href = checkout_url;
  
    const xhr = new XMLHttpRequest();
    const data = {};
    xhr.open('POST', '/cart/update.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      if (xhr.status === 200) {
        window.console.log('done', JSON.parse(xhr.responseText));
      } else if (xhr.status !== 200) {
        window.console.log('fail', JSON.parse(xhr.responseText));
      }
      const form = buildForm(data, checkout_url);
      document.body.appendChild(form);
      form.submit();
      };
    xhr.send(JSON.stringify(data));
  
  
    function buildInputs(form, obj) {
      // Build input fields for key, value pairs
      Object.keys(obj).forEach((key) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', typeof (obj[key]) === 'object' ? JSON.stringify(obj[key]) : obj[key]);
      form.appendChild(input);
      });
      }
      function buildForm(data, url) {
      // Build a virtual form
      const form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('action', url);
      form.setAttribute('id', 'rc_form');
      form.style.display = 'none';
      buildInputs(form, data);
      return form;
      }
  };

   /**
   * Close current open modal:
   */
  _closeModal = () => {
    document.body.classList.remove('overflow-hidden');
    var modal = document.querySelectorAll('.modal');
    modal.forEach(modalClose => {
      modalClose.classList.remove('open');
      siteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
    })
  }

  _closeCurrentModal = (ele) => {
    ele.closest('.modal').classList.remove('open');
  }
  _goBackModal = (ele) => {
    ele.closest('.modal').classList.remove('open');
    let inputs = document.querySelectorAll("input");
    let select = document.querySelectorAll('select');
    inputs.forEach((input) => (input.value = ""));
    select.forEach((select) => (select.value = ""));
  }
}

window.onload = () => {
  typeof giftJS !== 'undefined' && new giftJS();
}